import { alpha } from '@mantine/core'

import { colors } from 'src/theme/colors'

export const slideUpInitial = { opacity: 0, y: 20 } as const

export const slideUpAnimate = { opacity: 1, y: 0 } as const

export const cardSliderTransition = { duration: 0.4, delay: 0.3 } as const

export const sliderDotTransition = { duration: 0.3, ease: 'easeInOut' } as const

export const sliderDotAnimate = (isActive: boolean) =>
  ({
    width: isActive ? 32 : 8,
    backgroundColor: isActive ? colors.primary : colors.gray
  }) as const

export const articleEntranceTransition = { duration: 0.4 } as const

export const pageHeaderTitle = {
  initial: { opacity: 0, y: 12 },
  animate: { opacity: 1, y: 0 }
} as const

export const pageHeaderSubtitleTransition = {
  duration: 0.25,
  ease: 'easeOut' as const,
  delay: 0.06
} as const

export const tocIndicator = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  transition: { duration: 0.1 }
} as const

export const tocItemHover = { x: 4 } as const

export const tocItemHoverTransition = {
  duration: 0.15,
  ease: 'easeOut'
} as const

export const sectionCardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: (delay: number) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.4, delay }
  })
}

export const peopleRowAvatarVariants = {
  initial: { scale: 1 },
  hover: { scale: 1.1 }
}

export const peopleRowActionsVariants = {
  initial: { opacity: 0, x: 8 },
  hover: { opacity: 1, x: 0 }
}

export const peopleRowBackgroundVariants = {
  initial: { backgroundColor: 'transparent', borderRadius: '16px' },
  hover: { backgroundColor: alpha(colors.gray, 0.3), borderRadius: '16px' }
}

export const peopleRowBackgroundTransition = { duration: 0.2 } as const

export const peopleRowAvatarTransition = { duration: 0.2 } as const

export const peopleRowActionsTransition = { duration: 0.15 } as const
